export default __webpack_public_path__ + "static/media/Jiāo Tú.e0ecff31.png";